import {
     trigger,
     state,
     style,
     animate,
     transition,
} from '@angular/animations';

 export const slideInOut = [
     trigger('airport', [
          state('airport', style({ 
               width: '100%',
               opacity: 1,
               })
          ),
          state('route', style({ 
               width: '50%',
               opacity: 0,
               display: 'none' 
               })
          ),
          transition('airport => route', [animate('300ms ease-out')]),
          transition('route => airport', [animate('300ms 300ms ease-in')]),
        ]),

        trigger('route', [
          state('airport', style({ 
               opacity: 0, 
               display: 'none', 
               })
          ),
          state('route', style({
               width: '100%', 
               opacity: 1,
               })
          ),
          transition('airport => route', [animate('300ms 300ms ease-in-out')]),
          transition('route => airport', [animate('300ms ease-in-out')]),
        ]),
 ];

// export const slideInOut = [
//      trigger('airport', [
//           transition(':enter', [
//                style({
//                     opacity: 0,
//                }),
//                animate('300ms ease-in', style({ opacity: 1 })),
//           ]),
//           transition(':leave', [
//                animate('300ms ease-out', style({ opacity: 0 })),
//           ]),
//      ]),

//      trigger('route', [
//           transition(':enter', [
//                // style({
//                //      opactiy: 0,
//                // }),
//                animate('300ms ease-in', style({ opacity: 1 })),
//           ]),
//           transition(':leave', [
//                animate('300ms ease-out', style({ opacity: 0 })),
//           ]),
//      ]),
// ];

// export const stationFadeInOut = [
//      trigger('station', [
//           state('airport', style({ opacity: 1 })),
//           state('route', style({ opacity: 1 })),

//           transition('airport => route', [
//                animate('300ms ease-out', style({ opacity: 0 })),
//                style({ display: 'none' }),
//                animate('300ms ease-in', style({ opacity: 1 })),
//           ]),
//           transition('route => airport', [
//                animate('300ms ease-out', style({ opacity: 0, })),
//                style({ display: 'none' }),
//                animate('300ms ease-in', style({ opacity: 1 })),
//           ]),
//      ]),
// ];
